import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const submitContact = (data) => apiClient.post("/contact", data).then((r) => r.data);
export const submitVolunteer = (data) => apiClient.post("/volunteer", data).then((r) => r.data);
export const submitDonation = (data) => apiClient.post("/donate/intent", data).then((r) => r.data);
export const subscribeNewsletter = (email) =>
  apiClient.post("/newsletter", { email }).then((r) => r.data);
